<template>
  <div>
    <div class="demo-upload-list" v-for="item in fileList">
      <template v-if="item.status === 'finished'">
        <img width="100px" :src="item.url">
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>
  <Upload
    ref="upload"
    :with-credentials=true
    :headers="headers"
    :data="data"
    :show-upload-list="false"
    :default-file-list="defaultFileList"
    :on-success="onSuccess"
    accept="image/*"
    :before-upload="beforeUpload"
    type="drag"
    :action="action"
    :multiple="false"
    style="display: inline-block;width:58px;">
    <div style="width: 58px;height:58px;line-height: 58px;">
      <Icon type="ios-cloud-upload-outline" size="20">Select the file to upload</Icon>
    </div>
  </Upload>
    <Modal title="View Image" v-model="visible">
      <img :src="showImageUrl" v-if="visible" style="width: 100%">
    </Modal>
  </div>
</template>
<script>
  export default {
    name: 'MultiUpload',
    props: {
      defaultFileList: {
        type: [Array, Object],
        default () {
          return []
        }
      },
      params: {
        type: Object,
        default () {
          return {bucket: 'hellokid'}
        }
      },
      num: {
        type: [Number],
        default () {
          return 1
        }
      },
      text: {
        type: String,
        default () {
          return '点击或将文件拖拽到这里上传'
        }
      }
    },
    data () {
      return {
        action: '',
        visible: false,
        headers: {},
        data: this.params,
        largeImageUrl: '',
        fileList: [],
        fileIndex: 1,
        showIndex: 0,
        showImageUrl: '',
      }
    },
    methods: {
      handleView (item) {
        this.showImageUrl = item.url
        this.visible = true
      },
      handleRemove (file) {
        const fileList = this.fileList
        this.fileList.splice(fileList.map(item => item.uid).indexOf(file.uid), 1)
        this.emitInput(this.fileList)
      },
      onSuccess (res, file, fileList) {
        if (this.fileList.length >= this.num) {
          return
        }

        this.$Message.destroy()
        this.$Message.info('Upload success')

        file.uid = Date.now() + this.fileIndex++
        file.url = res.data.url
        file.name = res.data.name
        file.fileId = res.data.fileId
        file.size = res.data.size

        this.fileList.push(file)

        this.emitInput(this.fileList)
      },
      beforeUpload () {
        console.log('this.fileList.length ', this.fileList.length >= this.num)
        if (this.fileList.length >= this.num) {
          this.$Message.warning('single file only')
          return 
        }
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
        this.$Message.loading('Processing...', 0)
        return true
      },
      emitInput (fileList) {
        let v = fileList.map(item => {
          return {name: item.name, url: item.url, fileId: item.fileId, size: item.size}
        })
        this.$emit('on-file-change', v)
        this.$emit('input', v.map(item => item.fileId).join(','))
      },
      onCarouselClick () {
        this.visible = false
      }
    },
    watch: {
      defaultFileList: function (fileList) {
        this.fileList = fileList.map(item => {
          item.status = 'finished'
          item.percentage = 100
          item.uid = Date.now() + this.fileIndex++
          return item
        })
      }
    },
    created: function () {
      this.fileList = []
      this.action = this.$appConfig.baseUrl + '/upload/fileUpload'
    },
  }
</script>



// WEBPACK FOOTER //
// MultiUpload.vue?3b2df6d5